/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var spine_options_pb = require('../../spine/options_pb.js');
var spine_net_internet_domain_pb = require('../../spine/net/internet_domain_pb.js');
var spine_net_email_address_pb = require('../../spine/net/email_address_pb.js');
goog.exportSymbol('proto.spine.core.TenantId', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.core.TenantId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.spine.core.TenantId.oneofGroups_);
};
goog.inherits(proto.spine.core.TenantId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.core.TenantId.displayName = 'proto.spine.core.TenantId';
}
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.spine.core.TenantId.oneofGroups_ = [[1,2,20]];

/**
 * @enum {number}
 */
proto.spine.core.TenantId.KindCase = {
  KIND_NOT_SET: 0,
  DOMAIN: 1,
  EMAIL: 2,
  VALUE: 20
};

/**
 * @return {proto.spine.core.TenantId.KindCase}
 */
proto.spine.core.TenantId.prototype.getKindCase = function() {
  return /** @type {proto.spine.core.TenantId.KindCase} */(jspb.Message.computeOneofCase(this, proto.spine.core.TenantId.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.core.TenantId.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.core.TenantId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.core.TenantId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.core.TenantId.toObject = function(includeInstance, msg) {
  var f, obj = {
    domain: (f = msg.getDomain()) && spine_net_internet_domain_pb.InternetDomain.toObject(includeInstance, f),
    email: (f = msg.getEmail()) && spine_net_email_address_pb.EmailAddress.toObject(includeInstance, f),
    value: jspb.Message.getFieldWithDefault(msg, 20, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.core.TenantId}
 */
proto.spine.core.TenantId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.core.TenantId;
  return proto.spine.core.TenantId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.core.TenantId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.core.TenantId}
 */
proto.spine.core.TenantId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_net_internet_domain_pb.InternetDomain;
      reader.readMessage(value,spine_net_internet_domain_pb.InternetDomain.deserializeBinaryFromReader);
      msg.setDomain(value);
      break;
    case 2:
      var value = new spine_net_email_address_pb.EmailAddress;
      reader.readMessage(value,spine_net_email_address_pb.EmailAddress.deserializeBinaryFromReader);
      msg.setEmail(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.core.TenantId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.core.TenantId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.core.TenantId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.core.TenantId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDomain();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_net_internet_domain_pb.InternetDomain.serializeBinaryToWriter
    );
  }
  f = message.getEmail();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      spine_net_email_address_pb.EmailAddress.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 20));
  if (f != null) {
    writer.writeString(
      20,
      f
    );
  }
};


/**
 * optional spine.net.InternetDomain domain = 1;
 * @return {?proto.spine.net.InternetDomain}
 */
proto.spine.core.TenantId.prototype.getDomain = function() {
  return /** @type{?proto.spine.net.InternetDomain} */ (
    jspb.Message.getWrapperField(this, spine_net_internet_domain_pb.InternetDomain, 1));
};


/** @param {?proto.spine.net.InternetDomain|undefined} value */
proto.spine.core.TenantId.prototype.setDomain = function(value) {
  jspb.Message.setOneofWrapperField(this, 1, proto.spine.core.TenantId.oneofGroups_[0], value);
};


proto.spine.core.TenantId.prototype.clearDomain = function() {
  this.setDomain(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.core.TenantId.prototype.hasDomain = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional spine.net.EmailAddress email = 2;
 * @return {?proto.spine.net.EmailAddress}
 */
proto.spine.core.TenantId.prototype.getEmail = function() {
  return /** @type{?proto.spine.net.EmailAddress} */ (
    jspb.Message.getWrapperField(this, spine_net_email_address_pb.EmailAddress, 2));
};


/** @param {?proto.spine.net.EmailAddress|undefined} value */
proto.spine.core.TenantId.prototype.setEmail = function(value) {
  jspb.Message.setOneofWrapperField(this, 2, proto.spine.core.TenantId.oneofGroups_[0], value);
};


proto.spine.core.TenantId.prototype.clearEmail = function() {
  this.setEmail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.core.TenantId.prototype.hasEmail = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string value = 20;
 * @return {string}
 */
proto.spine.core.TenantId.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/** @param {string} value */
proto.spine.core.TenantId.prototype.setValue = function(value) {
  jspb.Message.setOneofField(this, 20, proto.spine.core.TenantId.oneofGroups_[0], value);
};


proto.spine.core.TenantId.prototype.clearValue = function() {
  jspb.Message.setOneofField(this, 20, proto.spine.core.TenantId.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.core.TenantId.prototype.hasValue = function() {
  return jspb.Message.getField(this, 20) != null;
};


goog.object.extend(exports, proto.spine.core);

// The code for parsing the Protobuf messages of this file from the JSON data.

let known_type_parsers = require('../../known_type_parsers.js');

proto.spine.core.TenantId.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.core.TenantId.fromObject(jsObject);
};

proto.spine.core.TenantId.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.core.TenantId();
  
  if (obj.domain !== undefined) {
    if (obj.domain === null) {
      msg.setDomain(null);
    } else {
      let value = proto.spine.net.InternetDomain.fromObject(obj.domain);
      msg.setDomain(value);
    }
  }
  
  if (obj.email !== undefined) {
    if (obj.email === null) {
      msg.setEmail(null);
    } else {
      let value = proto.spine.net.EmailAddress.fromObject(obj.email);
      msg.setEmail(value);
    }
  }
  
  if (obj.value !== undefined) {
    if (obj.value !== null) {
      let value = obj.value;
      msg.setValue(value);
    }
  }
  return msg;
};
